import {
  BASE_MODULE_DELETE,
  BASE_MODULE_INSERT,
  BASE_MODULE_UPDATE,
  BASE_MODULES_LIST,
  BASE_MODULES_PAGINATION,
} from "./constant";

const initialState = {
  baseModulesList: [],
  pagination: {},
  moduleTypeDropdown: [],
};

const BaseModulesReducer = (state = initialState, action) => {
  switch (action.type) {
    // ====================================
    // LIST
    // ====================================

    case BASE_MODULES_LIST:
      return {
        ...state,
        baseModulesList: action.payload,
      };

    // ====================================
    // PAGINATION
    // ====================================

    case BASE_MODULES_PAGINATION:
      return {
        ...state,
        pagination: action.payload,
      };

    // ====================================
    // INSERT DATA
    // ====================================

    case BASE_MODULE_INSERT:
      return {
        ...state,
        baseModulesList: [action.payload, ...state.baseModulesList],
      };

    // ====================================
    // UPDATE DATA
    // ====================================

    case BASE_MODULE_UPDATE:
      return {
        ...state,
        baseModulesList: state.baseModulesList.map((item) =>
          item.BASEMODULE_ID === action.payload?.BASEMODULE_ID
            ? action.payload
            : item,
        ),
      };

    // ====================================
    // DELETE DATA
    // ====================================

    case BASE_MODULE_DELETE:
      return {
        ...state,
        baseModulesList: state.baseModulesList.filter(
          (item) => item.BASEMODULE_ID !== action.payload,
        ),
          };
      
    case "SET_BASE_MODULE_TYPES":
      return {
        ...state,
        moduleTypeDropdown: action.payload,
      };

    default:
      return state;
  }
};

export default BaseModulesReducer;
